// Layout.jsx
import React from "react";
import Header from "./Header";
import InfoBanner from "./InfoBanner";
import "../../css/Layout.css";
import { useLocation } from "react-router-dom";


export default function Layout({ children }) {


const location = useLocation();

// list of routes where footer should be shown
const showFooterOn = ["/", "/review"]; 
const showFooter = showFooterOn.includes(location.pathname);

  return (
    <div className="app-layout">
      <Header />
      <InfoBanner/>
      <div className="app-body">{children}</div>
        <footer className="app-footer">
          <p className="app-footer-title"><b><a style={{color: "white"}} href="https://www.instagram.com/dadada_dada_da_da/" target="_blank">Powered by Dadada</a></b></p>
          <p style={{marginTop: 0, paddingTop: 0}}>
            Meta Invoice is not affiliated with Meta Platforms Inc, or their employees. By generating an invoice, you agree that your name and handle may appear publicly for artistic purposes. We don't store your payment details or sell your data. Meta does.
          </p>
        </footer>
      
    </div>
  );
}
